import { useMemo } from 'react';
import { buildTransferMap } from '../utils/transferMatcher';

export function useTransferMatcher(txs) {
  return useMemo(() => buildTransferMap(txs), [txs]);
}
